export default "__VITE_ASSET__DRBrqwev__"